"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _constants = _interopRequireDefault(require("@ahmdigital/constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getPromoCodeDescription = function getPromoCodeDescription(offer) {
  var _offer$canBeRedeemedW, _promoCode$descriptio;
  var promoCode = offer === null || offer === void 0 || (_offer$canBeRedeemedW = offer.canBeRedeemedWithPromoCode) === null || _offer$canBeRedeemedW === void 0 ? void 0 : _offer$canBeRedeemedW[0];
  if (!promoCode) {
    return null;
  }
  var description = promoCode === null || promoCode === void 0 || (_promoCode$descriptio = promoCode.description) === null || _promoCode$descriptio === void 0 || (_promoCode$descriptio = _promoCode$descriptio[0]) === null || _promoCode$descriptio === void 0 || (_promoCode$descriptio = _promoCode$descriptio.children) === null || _promoCode$descriptio === void 0 || (_promoCode$descriptio = _promoCode$descriptio[0]) === null || _promoCode$descriptio === void 0 ? void 0 : _promoCode$descriptio.text;
  if (!(0, _fp.isEmpty)(description)) {
    return {
      value: description
    };
  }
  var codeType = (promoCode === null || promoCode === void 0 ? void 0 : promoCode.codeType) || _constants["default"].OFFER_CODE_TYPE.PROMO;
  return {
    value: "Enter ".concat(codeType, " code if you join online")
  };
};
var _default = exports["default"] = getPromoCodeDescription;
module.exports = exports.default;